import { router, useLocalSearchParams } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaView } from 'react-native-safe-area-context';

import { AppText } from '@/components/ui/app-text';
import { Card } from '@/components/ui/card';
import { PrimaryButton } from '@/components/ui/primary-button';
import { colors, spacing } from '@/theme/tokens';

/** Placeholder for features under construction ("Wkrótce") */
export default function SoonScreen() {
  const { t } = useTranslation();
  const { title } = useLocalSearchParams<{ title?: string }>();

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: colors.background }} edges={['top', 'bottom']}>
      <View style={{ flex: 1, padding: spacing.screen, justifyContent: 'center' }}>
        <Card style={{ alignItems: 'center', gap: spacing.md }}>
          <Ionicons name="construct-outline" size={48} color={colors.primary} />
          <AppText variant="headlineMd" style={{ textAlign: 'center' }}>
            {title ?? t('common.soon')}
          </AppText>
          <AppText variant="bodyMd" style={{ textAlign: 'center' }}>
            {t('common.soonInfo')}
          </AppText>
          <PrimaryButton label={t('common.back')} onPress={() => router.back()} style={{ alignSelf: 'stretch' }} />
        </Card>
      </View>
    </SafeAreaView>
  );
}
